import React, { useState, useContext, useEffect, Fragment, useCallback } from "react";
import { LangCtx, SignalerCtx, PayLoadCtx, RoleCtx } from "../../../lib/context";

import "./styles.css";
import "../../../ui-styles/scroll/imageScroll.css";
import "../../../ui-styles/contentHeading/contentAnimationHdng.css";

//import "../bookAppointment/BookAppointments.css";
//import "../../../ui-styles/contentHeading/contentHeading.css";
//import "../../../ui-styles/contentHeading/contentAnimationHdng.css";
//import "../../../ui-styles/list/contactInfoList.css";

import Loader from "../../../lib/ui/loader/Loader";
import { useHistory, useParams } from "react-router-dom";
import { getappointmentData } from "../../../actions/appointment";
import { getDoctorFiles } from "../../../actions/users";
import PosterSlider from "./components/PostarSlider";
import VideoListItem from "./components/videoListItem";
import NoVideoItem from "./components/noVideoItem";
import NoPoster from "./components/noPoster";
//import NoPoster from "./components/noPoster;"
import IncommingCall from "../callingModals/incomingCallModal";
import Conference from "../../conference/conference";
// import InstaVC from "../../conference/libs/instavc";
import Roomclient from "../../conference/sdklib/Roomclient";
// import * as mediasoup from "mediasoup-client";
import getUserAgentData from "../../conference/sdklib/deviceInfo.js";
import BannerModal from "./components/bannerModal";
import VideoModal from "./components/videoModal";
import { getExperience, timeFormat } from "../../../lib/functions";
// import Conferencesdk from "../../conference/sdkconference";
import {API} from 'aws-amplify';

const WaitingRoom = (props) => {
    const { l } = useContext(LangCtx);
    const { signaler } = useContext(SignalerCtx);
    const { payload } = useContext(PayLoadCtx);
    const { role } = useContext(RoleCtx);
    const history = useHistory();
    const { id } = useParams();
    const [loading, setLoading] = useState(false);
    const [doctor, setDoctor] = useState({});
    const [images, setImages] = useState([]);
    const [videos, setVideos] = useState([]);
    const [appointment, setAppointmentData] = useState({});
    const [callerData, setCallerData] = useState(null);
    const [roomId, setRoomId] = useState(null);
    const [connecting, setConnecting] = useState(true);
    const [instaVC, setInstaVC] = useState(null);
    const [bnrModal, setBnrModal] = useState({ open: false, index: 0 });
    const [videoModal, setVideoModla] = useState({ openVideo: false, index: 0 });

    const handleBnrModalOpen = (index) => {
        setBnrModal({ open: true, index: index });
    };
    const handleBnrModalClose = () => {
        setBnrModal({ open: false, index: 0 });
    };

    const handleVideoModalOpen = (index) => {
        setVideoModla({ openVideo: true, index: index });
    };
    const handleVideoModalClose = () => {
        setVideoModla({ openVideo: false, index: 0 });
    };

    useEffect(() => {
        setLoading(true);

        getappointmentData(id)
            .then((res) => {
                props.match.params.name = false;
                if (res.status) {
                    if (res.data.appt_status === "confirmed") {
                        setAppointmentData(res.data);
                        setDoctor(res.data.doctorData);
                    } else {
                        history.push("/patient-dashboard");
                    }
                }
            })
            .catch((err) => {
                if(API.isCancel(err)) {
                    console.log("API is canceled................");
                } else {
                    setLoading(false);
                }
                history.push("/patient-dashboard");
                console.log("err in get appointment==== ", err);
            });
        // setInstaVC(new InstaVC(l));
        // const mediasoupdevice=mediasoup.Device();
        const device = getUserAgentData();
        if(instaVC === null){
            setInstaVC(new Roomclient({device}));
        }
    }, [id]);

    const handleUnload = useCallback((e) => {
        //  e.preventDefault();
        // endCallRequest();
        history.push("/");
        return "caneled";
    });

    useEffect(() => {
        //  window.addEventListener("beforeunload", handleUnload);
        // return () => window.removeEventListener("beforeunload", handleUnload);
    }, [handleUnload]);

    const setRedirect = async () => {
        console.log("ending::P", instaVC);
        if(instaVC){
            await instaVC.close()
        }
        history.push("/feedback", { appointment });
    };
    useEffect(() => {
        if (appointment?.endTime) {
            let diff = new Date(appointment.endTime).getTime() - new Date().getTime();
            setTimeout(setRedirect, diff);
        }
    }, [appointment]);

    useEffect(() => {
        if (signaler && doctor && doctor.userId) {

            signaler.on(`recive-call`, (message) => {
                setCallerData(message);
                setBnrModal({ open: false, index: 0 });
                setVideoModla({ openVideo: false, index: 0 });
            });
            signaler.on(`acerdec-call-ack`, (message) => {
                setCallerData(null);
                history.push("/")
            });
            signaler.on("cancel-call", () => {
                setCallerData(null);
            });
            signaler.on("enterwr-sent", () => {
                setConnecting(false);
            });
            signaler.enterWaitingRoom(id, doctor.userId);
            return () => {
                signaler.exitWaitingRoom(id, doctor.userId);
                signaler.off(`recive-call`, () => { });
                signaler.off(`acerdec-call-ack`, () => { });
                signaler.off(`cancel-call`, () => { });
                signaler.off(`enterwr-sent`, () => { });
            };
        }
    }, [doctor, signaler]);

    useEffect(() => {
        // setLoading(true);
        if (doctor.userId && appointment.clinicId) {
            getDoctorFiles(doctor.userId, appointment.clinicId)
                .then((res) => {
                    setLoading(false);
                    if (res.status) {
                        let _files = [...res.data];
                        let _videos = _files.filter((file) => file.uploadtype === "youtubeUrl" || file.uploadtype === "video/mp4");
                        let _images = _files.filter((file) => {
                            return (
                                file.uploadtype === "image/jpg" ||
                                file.uploadtype === "image/png" ||
                                file.uploadtype === "image/jpeg" ||
                                file.uploadtype === "image/gif" ||
                                file.uploadtype === "image/avif"
                            );
                        });
                        setVideos(_videos);
                        setImages(_images);
                    }
                })
                .catch((err) => {
                    if(API.isCancel(err)) {
                        console.log("API is canceled................");
                    } else {
                        setLoading(false);
                    }
                    console.log("err in loading doctors files ==== ", err);
                });
        }
    }, [doctor,appointment]);

    const declineRequest = () => {
        if (signaler) {
            signaler.declineCallRequest(doctor.userId, appointment.patientData);
            setCallerData(null);
        }
    };

    const handleAccept = () => {
        if (signaler) {
            signaler.acceptCallRequest(doctor.userId);
            setRoomId(callerData.roomId);
            setCallerData(null);
        }
    };

    const handleBack = () => {
        history.push("/");
    };

    const getFullName = (user_obj) => {
        let name = "Dr. ";
        name += user_obj.firstName ? user_obj.firstName + " " : "";
        name += user_obj.lastName ? user_obj.lastName : "";
        return name;
    };

    return (
        <Fragment>
            {/* <Beforeunload onBeforeunload={() => "You'll lose your data!"} /> */}
            {roomId !== null ? (
                <Conference id={id} roomId={roomId} appointmentData={appointment} instaVC={instaVC} role={role} payload={payload} />
            ) : (
                <div className="wtngCntnr">
                    <div className="wtngHdr">
                        <div className="backBox" title="Back to appointments" onClick={handleBack}></div>
                        <div className="appBarHdng">
                            <h2 className="topHdngTxt">{l.waitingroom}</h2>
                        </div>
                    </div>
                    <div className="wtngWhiteBox">
                        <div className="wtngDocBlock">
                            <div className="docInfoBlock">
                                <div className="docAvtrBlock">
                                    {doctor.profileImage ? (
                                        <img src={doctor.profileImage.url} alt="avatar" />
                                    ) : (
                                        <img src="/images/icons/doctor-default.png" alt="avatar" />
                                    )}
                                </div>
                                <div className="docDitls">
                                    <span className="docNmTxt">{getFullName(doctor)}</span>
                                    <span className="docDepTxt">
                                        <span className="profleSTxt">
                                            {doctor.qualification ? doctor.qualification : ""}
                                            {doctor.department ? `(${doctor.department})` : ""}
                                            {doctor.serviceStartDate ? `- ${getExperience(new Date(doctor.serviceStartDate))}` : ""}
                                        </span>
                                    </span>
                                </div>
                            </div>
                            <div className="scdulTimeBlock">
                                {appointment && (
                                    <span className="consultTxtL">
                                        {l.consult_time}: <small className="consultTxtS">{timeFormat(appointment.startTime)}</small>
                                    </span>
                                )}
                                <div className="animatedHdngCol">
                                    <span className="animatedHdng">{l.pls_wait}</span>
                                    <span className="animatedHdngS">
                                        {l.doc_msg}
                                        <span>.</span>
                                        <span>.</span>
                                        <span>.</span>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>

                    {loading || connecting ? (
                        <Loader />
                    ) : (
                        <>
                            <div className="imgScrlCntnr">
                                <div className="bnrHdr">
                                    <span className="bnrHdrTxt">{l.banners}</span>
                                </div>

                                <div className="innerScrlCntnr">
                                    {images.length > 0 ? (
                                        images.map((image, i) => (
                                            <PosterSlider data={image} key={image.url} openBnrMobal={(e) => handleBnrModalOpen(i)} />
                                        ))
                                    ) : (
                                        <NoPoster heading={"No poster upload"} />
                                    )}
                                </div>
                            </div>

                            <div className="wrVdoCntnr">
                                <div className="bnrHdr">
                                    <span className="bnrHdrTxt">{l.upload_vid}</span>
                                    <span className="bnrHdrTxtS">{l.upload_vid_desc}</span>
                                </div>
                                <div className="wcVdoWrpr">
                                    {videos.length > 0 ? (
                                        videos.map((video, i) => (
                                            <VideoListItem
                                                data={video}
                                                key={video.url}
                                                label={l.vid_list}
                                                openVideoModal={(e) => handleVideoModalOpen(i)}
                                            />
                                        ))
                                    ) : (
                                        <NoVideoItem noVideoLabel={l.no_vid_upload} />
                                    )}
                                </div>
                            </div>
                        </>
                    )}

                    {callerData !== null && (
                        <IncommingCall
                            inCall={callerData !== null}
                            handleInCall={() => declineRequest()}
                            userData={callerData}
                            handleAccept={handleAccept}
                        />
                    )}
                </div>
            )}
            {bnrModal && bnrModal.open && images && images.length > 0 && (
                <BannerModal
                    data={images[bnrModal.index]}
                    total={images.length}
                    current={bnrModal.index}
                    handleChange={handleBnrModalOpen}
                    handleClose={handleBnrModalClose}
                />
            )}

            {videoModal && videoModal.openVideo && videos && videos.length > 0 && (
                <VideoModal
                    data={videos[videoModal.index]}
                    total={videos.length}
                    current={videoModal.index}
                    handleChange={handleVideoModalOpen}
                    handleClose={handleVideoModalClose}
                />
            )}
        </Fragment>
    );
};

export default WaitingRoom;
